
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-competition/product/[id]",
      function () {
        return require("private-next-pages/ai-competition/product/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-competition/product/[id]"])
      });
    }
  